import HttpProvider from "./httpProvider"
import { API } from "../constants/api"

class DellinService {
  constructor() {
    this.http = HttpProvider
  }

  async getRequest(id) {
    return await this.http.get(API.DELLIN.GET_REQUEST({ id }), false)
  }

  async getTerminals(idRequest, direction = "from") {
    const body = { search: "", idRequest, direction }
    return await this.http.post(API.DELLIN.GET_TERMINALS({}), body)
  }

  async getCities(search = "", idRequest, direction = "from") {
    const body = { searchString: search, idRequest, direction }
    return await this.http.post(API.DELLIN.GET_CITIES({}), body)
  }

  async getCity(search = "") {
    const body = { searchString: search }
    return await this.http.post(API.DELLIN.GET_CITY({}), body)
  }

  async getStreets(search = "", cityID = "") {
    const body = { search, cityID }
    return await this.http.post(API.DELLIN.GET_STREETS({}), body)
  }

  async getStreet(search = "") {
    const body = { search: search }
    return await this.http.post(API.DELLIN.GET_STREET({}), body)
  }

  async getContragents() {
    return await this.http.get(API.DELLIN.GET_CONTRAGENTS({}), false)
  }

  async save(data) {
    return await this.http.put(API.DELLIN.SAVE({ id: data?.id }), data)
  }

  async createOrder(id) {
    return await this.http.get(API.DELLIN.CREATE_REQUEST({ id }), false)
  }

  async getTracking(id) {
    return await this.http.get(API.DELLIN.GET_TRACKING({ id }), false)
  }

  async getResponse(id) {
    return await this.http.get(API.DELLIN.GET_RESPONSE({ id }), false)
  }

  async getScheduleTerminal(id) {
    return await this.http.get(API.DELLIN.GET_SCHEDULE_TERMINAL({ id }), false)
  }

  async getContactPersons(contragentId = -1) {
    return await this.http.get(API.DELLIN.GET_PERSONS({ id: contragentId }), false)
  }
}

export default new DellinService()
